import { useMemo, useState } from 'react';
import { GetPatientsBalanceResponse_PatientBalance } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { searchByText } from '../../utils';
import { FilterKeys, FilterValues } from './types';

export const useFilters = (data: GetPatientsBalanceResponse_PatientBalance[]) => {
  const [filters, setFilters] = useState<FilterValues>({
    textSearch: '',
    location: '',
    balanceTypes: [],
  });

  const handleFilterChange = (type: FilterKeys, value: FilterValues[FilterKeys]) => {
    setFilters((prev) => ({ ...prev, [type]: value }));
  };

  const datum = useMemo(() => {
    let filteredData = data;
    if (filters.textSearch) {
      filteredData = searchByText(filteredData, filters.textSearch);
    }

    if (filters.location) {
      filteredData = filteredData.filter((patient) => patient.locationIds?.includes(filters.location));
    }

    if (filters.balanceTypes.length > 0) {
      filteredData = filteredData.filter((patient) => filters.balanceTypes.includes(patient.balanceType));
    }
    return filteredData;
  }, [filters]);

  return {
    filters,
    data: datum,
    handleFilterChange,
  };
};
